module.exports = __webpack_public_path__ + "static/media/BackgroundQuestions.5b32a20d.png";